;
(function (ng) {
  'use strict';

  angular.module('dom', []);
})(angular);